import MyDna from "./MyDna";
export default MyDna;
